// =============================================================================
// JsonViewer — collapsible read-only JSON renderer
// =============================================================================
// Props: { data, title }

import { useState } from 'react';

export default function JsonViewer({ data, title }) {
  const [open, setOpen] = useState(false);
  const isEmpty = data == null ||
    (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) ||
    (Array.isArray(data) && data.length === 0);

  return (
    <div className="border border-gray-200 rounded-md overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-gray-50 text-sm font-bold text-silver-text hover:bg-gray-100 transition-colors"
      >
        <span>{title}</span>
        <span className="text-silver-mute text-xs">{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <pre className="bg-white text-xs font-mono text-silver-text p-4 overflow-auto max-h-64 whitespace-pre-wrap break-all border-t border-gray-200">
          {isEmpty ? '(empty)' : JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}
